export default "__VITE_ASSET__CLwqEVad__"